export default "data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAAAwAwCdASooABcAPt1sr1IopaQipWgBEBuJZQDL4A8xTkjgAP7vSe863vSywJbI1jnGxtoXw19JsPYDAzCXmp8joAA="